/**
 * PathPal Blog Template JavaScript
 * Handles category filtering for blog posts
 */

document.addEventListener('DOMContentLoaded', () => {
  const categoryTabs = document.querySelector('.category-tabs');
  
  if (!categoryTabs) return;

  const blogHandle = categoryTabs.dataset.blogHandle || 'news';

  categoryTabs.addEventListener('click', (e) => {
    if (e.target.classList.contains('category-tab')) {
      const category = e.target.dataset.category;
      const tag = e.target.dataset.tag;

      // Update active state
      categoryTabs.querySelectorAll('.category-tab').forEach(tab => {
        tab.classList.remove('active');
      });
      e.target.classList.add('active');

      // Navigate to filtered URL
      if (category === 'all') {
        window.location.href = `/blogs/${blogHandle}`;
      } else {
        // Use the handle (URL-safe version) instead of the raw tag
        window.location.href = `/blogs/${blogHandle}/tagged/${category}`;
      }
    }
  });

  // Smooth scroll for skip links
  const skipLink = document.querySelector('.skip-link');
  if (skipLink) {
    skipLink.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(skipLink.getAttribute('href'));
      if (target) {
        target.focus();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});